export const ACTIVITES_ID = {
    karting: '18b28f95-abc9-4235-99bb-91c5920753a9',
    trampolines: 'c55e8fe1-0daf-47c9-bb07-6a0599ca6bb1',
    bowling: '8eb8e1c2-f6e7-45a2-b675-32ed62ca1bcc',
    billard: '9fda8554-a5f5-4089-848d-03c806e37a0e',
    [`réalité virtuelle`]: 'dc80e980-f9f4-4c1f-adf6-6f14c63bd2c7',
    [`pack duo`]: '1e3859c8-ce4d-479b-bdc8-bc4acfa42bc7',
    anniversaire: '661c281e-540c-4399-9c5d-6acc64ec10d8',
    evenements: '62028801-0b71-4620-b967-4738a96c8afd',
    entreprise: '1bf06c18-b7c6-41f3-8256-063b94964dac',
    [`jeudi étudiant`]: '62028801-0b71-4620-b967-4738a96c8afd',
    abonnements: '0e45b42d-5c96-4882-bf89-3ab6a90e1ed2',
    snaking: '7d278060-70f6-433c-ace2-645998774a78',
};
